export default {"src":"/_next/static/media/rocketTwo.40ab78e6.svg","height":25,"width":25};